import { get, post, _delete } from './Tools';

const uploadDocumento = async (payload) => {
  const response = await post(
    `${process.env.REACT_APP_SERVER}documentos-empleado/upload`,
    payload
  );
  return response;
};

const getDocumentosByEmpleado = async (empleadoId) => {
  const response = await get(
    `${process.env.REACT_APP_SERVER}documentos-empleado/empleado/${empleadoId}`
  );
  return response;
};

const downloadDocumento = async (documentoId) => {
  const response = await get(
    `${process.env.REACT_APP_SERVER}documentos-empleado/documento/${documentoId}/download`
  );
  return response;
};

const deleteDocumento = async (documentoId) => {
  const response = await _delete(
    `${process.env.REACT_APP_SERVER}documentos-empleado/documento/${documentoId}`
  );
  return response;
};

export { uploadDocumento, getDocumentosByEmpleado, downloadDocumento, deleteDocumento };
